import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  tap,
  switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectManagementActions from './project-management.actions';
import { ProjectManagementService } from '../../services/project-management.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectManagementEffects {
  loadProjectManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.loadProjectManagement),
      exhaustMap((_) =>
        this.projectManagementService.getProjectManagement().pipe(
          map((data) =>
            ProjectManagementActions.loadProjectManagementSuccess({
              projectManagement: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectManagementActions.loadProjectManagementFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.addProjectManagement),
      concatMap(({ newProjectManagement }) =>
        this.projectManagementService
          .createProjectManagement(newProjectManagement)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectManagementActions.addProjectManagementSuccess({
                newProjectManagement: data,
              });
            }),
            catchError((error) =>
              of(
                ProjectManagementActions.addProjectManagementFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  addProjectSubManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.addProjectSubManagement),
      concatMap(({ newProjectSubManagement }) =>
        this.projectManagementService
          .createProjectSub(newProjectSubManagement)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectManagementActions.addProjectSubManagementSuccess({
                newProjectSubManagement: data,
              });
            }),
            catchError((error) =>
              of(
                ProjectManagementActions.addProjectSubManagementFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  // addProjectSubManagementSuccess$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(ProjectManagementActions.addProjectSubManagementSuccess),
  //       tap(() => {
  //         console.log('navigate');
  //         return this.router.navigate([ '/project' ]);
  //       })
  //     ),
  //   { dispatch: false }
  // );

  // updateSuccess$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(ProjectManagementActions.addProjectSubManagementSuccess),
  //       tap(() => {
  //         console.log('navigate');
  //         return this.router.navigate([ '/project/monitor' ]);
  //       })
  //     ),
  //   { dispatch: false }
  // );

  uploadExcelProjectManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.uploadExcelStudentRecord),
      concatMap(({ uploadExcelRecord }) =>
        this.projectManagementService
          .uploadExcelProjectManagement(uploadExcelRecord)
          .pipe(
            map((data) => {
              this.notification.success('Uploaded Successfully');
              return ProjectManagementActions.uploadExcelStudentRecordSuccess({
                uploadExcelRecord: data,
              });
            }),
            catchError((error) =>
              of(
                ProjectManagementActions.uploadExcelStudentRecordFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateProjectManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.updateProjectManagement),
      concatMap(({ updateProjectManagement }) =>
        this.projectManagementService
          .updateProjectManagement(updateProjectManagement)
          .pipe(
            map((data) => {
              this.notification.success('Updated Successfully');
              return ProjectManagementActions.updateProjectManagementSuccess({
                updateProjectManagement: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectManagementActions.updateProjectManagementFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  removeProjectManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagement),
      map((action) => action.ids),
      switchMap((ids) =>
        this.projectManagementService.deleteProjectManagement(ids).pipe(
          map((data) => {
            this.notification.success('Deleted Successfully');
            return ProjectManagementActions.removeProjectManagementSuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ProjectManagementActions.updateProjectManagementFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeProjectManagementStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagementStakeholder),
      map((action) => action.ids),
      switchMap((ids) =>
        this.projectManagementService
          .deleteProjectManagementStakeholder(ids)
          .pipe(
            map((data) => {
              this.notification.success('Deleted Successfully');
              return ProjectManagementActions.removeProjectManagementStakeholderSuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                ProjectManagementActions.removeProjectManagementStakeholderFailure(
                  {
                    error: error.message,
                  }
                )
              )
            )
          )
      )
    )
  );

  removeProjectManagementCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagementCluster),
      map((action) => action.ids),
      switchMap((ids) =>
        this.projectManagementService.deleteProjectManagementCluster(ids).pipe(
          map((data) => {
            this.notification.success('Deleted Successfully');
            return ProjectManagementActions.removeProjectManagementClusterSuccess(
              { ids }
            );
          }),
          catchError((error) =>
            of(
              ProjectManagementActions.removeProjectManagementClusterFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeProjectManagementMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagementReportMaster),
      map((action) => action.ids),
      switchMap((ids) =>
        this.projectManagementService
          .deleteProjectManagementReportMaster(ids)
          .pipe(
            map((data) => {
              this.notification.success('Deleted Successfully');
              return ProjectManagementActions.removeProjectManagementReportMasterSuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                ProjectManagementActions.removeProjectManagementReportMasterFailure(
                  {
                    error: error.message,
                  }
                )
              )
            )
          )
      )
    )
  );

  removeProjectManagementMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagementReportMeeting),
      map((action) => action.ids),
      switchMap((ids) =>
        this.projectManagementService.deleteProjectManagementMeeting(ids).pipe(
          map((data) => {
            this.notification.success('Deleted Successfully');
            return ProjectManagementActions.removeProjectManagementReportMeetingSuccess(
              { ids }
            );
          }),
          catchError((error) =>
            of(
              ProjectManagementActions.removeProjectManagementReportMeetingFailure(
                {
                  error: error.message,
                }
              )
            )
          )
        )
      )
    )
  );

  removeProjectManagementMain$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectManagementActions.removeProjectManagementMain),
      map((action) => action.id),
      switchMap((id) =>
        this.projectManagementService.deleteProjectManagementMain(id).pipe(
          map((data) => {
            this.notification.success('Deleted Successfully');
            return ProjectManagementActions.removeProjectManagementMainSuccess({
              id,
            });
          }),
          catchError((error) =>
            of(
              ProjectManagementActions.removeProjectManagementMainFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectManagementService: ProjectManagementService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
